import { WebHttpClientWithErrorToastInstance } from '~src/httpClient/WebHttpClientWithErrorToast';

import { CreateRoutingFilterRequest, ICreateRoutingFilterParams } from '../requests/CreateRoutingFilterRequest';
import { DeleteRoutingFilterRequest, IDeleteRoutingFilterParams } from '../requests/DeleteRoutingFilterRequest';
import { EditRoutingFilterRequest, IEditRoutingFilterParams } from '../requests/EditRoutingFilterRequest';
import { GetRoutingFiltersRequest, IGetRoutingFiltersParams, IGetRoutingFiltersResult } from '../requests/GetRoutingFiltersRequest';
import { IRoutingFilterResult } from '../requests/RoutingFilterTypes';

export namespace RoutingFilter {

  export function getRoutingFilters(params: IGetRoutingFiltersParams): Promise<IGetRoutingFiltersResult> {
    return WebHttpClientWithErrorToastInstance.sendRequest(new GetRoutingFiltersRequest(params));
  }

  export function createRoutingFilter(params: ICreateRoutingFilterParams): Promise<IRoutingFilterResult> {
    return WebHttpClientWithErrorToastInstance.sendRequest(new CreateRoutingFilterRequest(params));
  }

  export function editRoutingFilter(params: IEditRoutingFilterParams): Promise<IRoutingFilterResult> {
    return WebHttpClientWithErrorToastInstance.sendRequest(new EditRoutingFilterRequest(params));
  }

  export function deleteRoutingFilter(params: IDeleteRoutingFilterParams): Promise<IRoutingFilterResult> {
    return WebHttpClientWithErrorToastInstance.sendRequest(new DeleteRoutingFilterRequest(params));
  }
}
